import React from "react";

export default function Header()
{
  return (
    <section className="home-header">
      <div className="container text-center">
        <div className="block_50"></div>
        <div className="block_100  "></div>
        <div className="header_w  ">

          <h1 className="mr_b-20 wow fadeInUp" >
            Welcome to Rocket Racoon <br></br>

            <strong> The mission of the Rocket Raccoon is to build a blockchain ecosystem and reach the new heights!
              ROC Smart Chain</strong> </h1>

          <div className="block_10"></div>
          <button className="reset_btn  btn_dark btn_dark_lg wow fadeInUp " >ROC Smart Chain</button>

          <div className="ic__">
            <div className="img__"></div>
          </div>
        </div>

      </div>

    </section>
  );
}
